import { render, staticRenderFns } from "./PlayerPlaceholder.vue?vue&type=template&id=4b4c4336&scoped=true&"
import script from "./PlayerPlaceholder.vue?vue&type=script&lang=js&"
export * from "./PlayerPlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./PlayerPlaceholder.vue?vue&type=style&index=0&id=4b4c4336&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4c4336",
  null
  
)

export default component.exports